<template>
  <cs-modal v-model="shown" color-overlay="#b979e533" :content-position="contentPosition">
    <div slot="content-wrapper" class="modal-container">
      <div ref="scrollContent" class="modal-content">
        <h4 class="modal-title" v-html="$t('choose.reason.for.check.annulment')"></h4>
        <div class="receipt-cancel-reasons-list">
          <div
            v-for="({ code, icon, description }) in receiptCancelReasons"
            :key="code"
            class="receipt-cancel-reason"
            @click="onReceiptCancel(code)"
          >
            <capusta-panel
              :icon="icon"
              :description="description"
            />
          </div>
        </div>
        <div class="modal-button-container">
          <button class="modal-button cancel" @click="onClose">
            {{ $t('common.cancel') }}
          </button>
        </div>
      </div>
    </div>
  </cs-modal>
</template>

<script>
import { mapGetters } from 'vuex';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

import CapustaPanel from 'modules/CapustaLayout/CapustaPanel';

export default {
  name: 'AnnulledDeclarationModal',
  components: {
    CapustaPanel,
  },
  props: {
    value: Boolean,
    transactionId: {
      type: String,
      required: true,
    },
    receiptCancelReasons: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      shown: false,

    };
  },
  computed: {
    contentPosition() {
      if (this.isDesktop) {
        return 'center';
      }
      return 'flex-end';
    },
    ...mapGetters(['isDesktop']),
  },
  watch: {
    value(val) {
      this.shown = val;
    },
    shown(val) {
      this.$emit('input', val);

      if (val) {
        disableBodyScroll(this.$refs.scrollContent);
      } else {
        enableBodyScroll(this.$refs.scrollContent);
      }
    },
  },
  methods: {
    onClose() {
      this.shown = false;
    },
    async onReceiptCancel(code) {
      this.onClose();
      await this.$nextTick();
      this.$emit('receipt-cancel', code);
    },
  },
};
</script>

<style lang="sass" scoped>
  .modal-container
    width: 100%
    background: #181823
    background-image: url("~@/assets/img/self-employed/what.png")
    background-repeat: no-repeat
    background-position: top 10px right

    +respond-to("small")
      width: 500px
      border-radius: 10px
      background-position: top 60px right

  .modal-content
    padding: 20px

    +respond-to("small")
      padding: 50px 50px 15px

  .modal-title
    margin-bottom: 20px
    font-weight: 600
    font-size: 20px
    line-height: 30px
    color: #fff

    +respond-to("small")
      margin-bottom: 40px

  .modal-button-container
    display: flex
    justify-content: center

  .modal-button
    width: 100%
    height: 50px
    font-weight: 600
    font-size: 18px
    line-height: 18px
    color: #fff
    background: #181823
    border-radius: 50px

  .receipt-cancel-reasons-list
    margin-bottom: 15px

  .receipt-cancel-reason
    cursor: pointer

    &:not(:last-child)
      margin-bottom: 10px

    button
      margin-bottom: 10px
      display: block
      padding: 16px
      font-weight: 600
      font-size: 18px
      line-height: 18px
      border-radius: 2rem
      background-color: #7CB342
      box-shadow: inset 0px -1px 0px rgba(0, 0, 0, 0.25)

      &:hover
        box-shadow: inset 0 -0.24rem 0 rgba(0, 0, 0, 0.2), 0 0.24rem 0.24rem rgba(124, 179, 66, 0.2)

</style>
